const START_RECORD = 'record/START_RECORD';
const AUDIO_STATE = 'record/AUDIO_STATE';
const VIDEO_STATE = 'record/VIDEO_STATE';

const initialState = {
    start: false,
    video: true,
    audio: true
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case START_RECORD:
        return Object.assign({}, state, {
            start: action.start
        });
    case AUDIO_STATE:
        return Object.assign({}, state, {
            audio: action.audio
        });
    case VIDEO_STATE:
        return Object.assign({}, state, {
            video: action.video
        });
    default:
        return state;
    }
};
const setStartRecord = start => ({
    type: START_RECORD,
    start: start
});
const setVideo = video => ({
    type: VIDEO_STATE,
    video: video
});
const setAudio = audio => ({
    type: AUDIO_STATE,
    audio: audio
});

export {
    reducer as default,
    initialState as recordInitialState,
    setStartRecord,
    setAudio,
    setVideo
};
